const RENTANG_TD = { sistole: [60, 260], diastole: [30, 160] };

const POLA_TD = /^(\d{1,3})\/(\d{1,3})$/;

export function maskTekananDarah(val: string, sebelumnya: string): string {
  const lama = String(sebelumnya || "");
  let bersih = String(val || "").replace(/[^\d/]/g, "");

  const bagian = bersih.split("/");
  bersih =
    bagian.length > 1
      ? `${bagian[0].slice(0, 3)}/${bagian
          .slice(1)
          .join("")
          .slice(0, 3)}`
      : bagian[0].slice(0, 3);

  const sedangMengetik = bersih.length > lama.length;
  if (sedangMengetik && bersih.length === 3 && bersih.indexOf("/") === -1) {
    bersih += "/";
  }

  return bersih;
}

export function validasiTekananDarah(v: string): true | string {
  if (!v) return true;

  const cocok = POLA_TD.exec(v);
  if (!cocok) return "Format tekanan darah: xxx/xx, misal 120/80";

  const nilai = { sistole: Number(cocok[1]), diastole: Number(cocok[2]) };
  for (const bagian of ["sistole", "diastole"] as const) {
    const [min, max] = RENTANG_TD[bagian];
    if (nilai[bagian] < min || nilai[bagian] > max) {
      return `${
        bagian === "sistole" ? "Sistole" : "Diastole"
      } di luar rentang ${min}-${max} mmHg`;
    }
  }
  if (nilai.sistole <= nilai.diastole) {
    return "Sistole harus lebih tinggi dari diastole";
  }

  return true;
}
